import { useEffect, useState } from 'react'
import { LoadingWrapper, WrapperProps } from '../components'
import baseConfig from '../config.json'
import { createContextFactory } from './utils'
import { ConfigType } from './types'
import { CLIENT_CONFIG_FILE_PATH, extend, fetchData } from '../utils'

const [useConf, ConfigContextProvider] = createContextFactory<ConfigType>(
  'useConf',
  'ConfigContextProvider'
)

const ConfigProvider = ({ children }: WrapperProps) => {
  const [conf, setConf] = useState<ConfigType | undefined>(undefined)

  useEffect(() => {
    const fetchConfig = async () => {
      const clientConfigData = await fetchData(CLIENT_CONFIG_FILE_PATH)
      setConf(extend(baseConfig, clientConfigData))
    }

    fetchConfig()
  }, [])

  return (
    <LoadingWrapper isLoading={conf === undefined}>
      <ConfigContextProvider value={conf}>{children}</ConfigContextProvider>
    </LoadingWrapper>
  )
}

export { ConfigProvider, useConf }
